<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal chat-modal">
      <div class="modal-header chat-header">
        <div class="chat-header-info">
          <div class="chat-avatar">
            <mat-icon>handshake</mat-icon>
          </div>
          <div class="chat-header-text">
            @if (data?.negotiation?.id) {
              <h3 class="modal-title">Negociação #{{ data.negotiation.id }}</h3>
              <span class="chat-status">Ativa</span>
            }
          </div>
        </div>
        <button mat-icon-button mat-dialog-close class="chat-close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body chat-body" #chatDiv>
        <div class="chat-content">
          @if(chats.length >= displaySize) {
            <div class="chat-load-more" (click)="scrollToTop()">
              <span class="badge badge-primary">
                <mat-icon>expand_more</mat-icon>
                Carregar mensagens antigas
              </span>
            </div>
          }

          @if (chats.length === 0) {
            <div class="chat-empty">
              <div class="chat-empty-icon-wrapper">
                <mat-icon class="chat-empty-icon">chat_bubble_outline</mat-icon>
              </div>
              <p class="chat-empty-title">Nenhuma mensagem ainda</p>
              <p class="chat-empty-subtitle">Envie a primeira mensagem para iniciar a negociação</p>
            </div>
          }

          @if (chats) {
            @for (chat of chats; track $index) {
              @if(displayLimit($index)) {
                <div class="chat-message-wrapper" 
                     [ngClass]="isUserSender(chat.userSender) ? 'chat-message-sent' : 'chat-message-received'">
                  
                  @if(!isUserSender(chat.userSender)) {
                    <div class="chat-avatar-small">
                      <mat-icon>person</mat-icon>
                    </div>
                    <div class="chat-bubble">
                      <div class="chat-sender-name">
                        {{ getName(chat.userSender) }}
                      </div>
                      <div class="chat-text">{{ chat.message }}</div>
                      <div class="chat-timestamp">
                        {{ chat.dateTime | date : "dd/MM/yyyy - HH:mm" }}
                        @if(chat.edited) {
                          <span class="chat-edited">(editada)</span>
                        }
                      </div>
                    </div>
                  } @else {
                    <div class="chat-bubble">
                      <div class="chat-text">{{ chat.message }}</div>
                      <div class="chat-timestamp">
                        {{ chat.dateTime | date : "dd/MM/yyyy - HH:mm" }}
                        @if(chat.edited) {
                          <span class="chat-edited">(editada)</span>
                        }
                      </div>
                    </div>
                    <div class="chat-avatar-small chat-avatar-sent">
                      <mat-icon>account_circle</mat-icon>
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer chat-footer">
        <div class="chat-input-container">
          <mat-form-field appearance="outline" class="chat-input-field">
            <input
              matInput
              [(ngModel)]="messageInput"
              (keyup.enter)="sentMessage()"
              placeholder="Digite sua mensagem..."
            />
          </mat-form-field>
          <button 
            mat-fab 
            color="primary" 
            (click)="sentMessage()" 
            [disabled]="!messageInput.trim()"
            class="chat-send-button">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </div>
</div>
